import { useQuery, UseQueryOptions } from 'react-query';

import { FinancialCovenantType } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useFinancialCovenantTypesQuery(
	options?:
		| Omit<UseQueryOptions<FinancialCovenantType[], unknown, FinancialCovenantType[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Lookups.FinancialCovenantTypes,
		() =>
			AxiosUtils.getResponseData<FinancialCovenantType[]>(
				api.get(CerebroApiEndpoints.Lookups.FinancialCovenantTypes)
			),
		options
	);
}
